import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const borderColor = "#90e5fc";
const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    borderBottomColor: "#bff0fd",
    borderBottomWidth: 1,
    minHeight: 30,
    flexGrow: 1,
    fontSize: "9px",
    alignItems: "center",
  },

  text: {
    width: "35%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "left",
    marginLeft: 10,
  },
  date: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },

  transaction: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  outstanding: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "right",
  },
  width5: {
    width: "5%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  width10: {
    width: "10%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  width15: {
    width: "15%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
  width20: {
    width: "20%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
  },
  width40: {
    width: "35%",
    borderRightColor: borderColor,
    borderRightWidth: 1,
    textAlign: "center",
  },
});
export class ProductPurchaseMainTable extends React.Component {
  render() {
    let { items } = this.props;
    return items.map((item, index) => (
      <View style={styles.row} key={index}>
        <Text style={styles.width15}>{item.sa_date}</Text>
        <Text style={styles.width10}>{item.transaction}</Text>
        <Text style={styles.width40}>{item.dt_itemdesc}</Text>
        <Text style={styles.width10}>{item.dt_qty}</Text>
        <Text style={styles.width10}>{item.dt_promoprice}</Text>
        <Text style={styles.width10}>{item.dt_transacamt}</Text>
        <Text style={styles.width10}>{item.dt_staffname}</Text>
      </View>
    ));
  }
}
